/**
 * @packageDocumentation
 * @module dom/query
 */

export type TQueryFocusable = string;

/**
 * { @link TQueryFocusable }
 */
export default '[focusable], [href], object, embed, [tabindex]:not([disabled]), [contenteditable]';
